var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61311 21H8.36061C8.69247 21 8.96249 20.73 8.96249 20.3981V15.6562C8.96249 15.3244 8.69247 15.0544 8.36061 15.0544H6.61124V12.6019H17.4112V15.0544H15.6394C15.3075 15.0544 15.0375 15.3244 15.0375 15.6562V20.3981C15.0375 20.73 15.3075 21 15.6394 21H20.3868C20.7187 21 20.9887 20.73 20.9887 20.3981V15.6562C20.9887 15.3244 20.7187 15.0544 20.3868 15.0544H18.615V12C18.615 11.6681 18.345 11.3981 18.0131 11.3981H12.6131V8.94562H14.385C14.7169 8.94562 14.9868 8.6756 14.9868 8.34374V3.60188C14.9868 3.26999 14.7169 3 14.385 3H9.63746C9.31124 3 9.04121 3.26999 9.04121 3.60188V8.34375C9.04121 8.67561 9.31124 8.94563 9.63746 8.94563H11.415V11.3981H6.01496C5.68311 11.3981 5.41312 11.6681 5.41312 12V15.0544H3.61311C3.28122 15.0544 3.01123 15.3244 3.01123 15.6563V20.3981C3.01123 20.73 3.28122 21 3.61311 21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/Work flow.04bcb9e2d58b8c8ca30dc1a6bae6c304.svg";
export { ForwardRef as ReactComponent };